import React from 'react';
import { Building2, Users, Briefcase, Lightbulb } from "lucide-react";

const targets = [
  {
    title: "Startups",
    description: "Fondateurs et équipes de startups innovantes cherchant à développer leur MVP ou à accélérer leur croissance.",
    icon: Lightbulb,
    characteristics: [
      "Vision claire du projet",
      "Marché identifié",
      "Ressources financières disponibles",
      "Équipe dédiée au projet"
    ]
  },
  {
    title: "Professionnels Indépendants",
    description: "Experts et consultants de tous secteurs cherchant à développer leur activité ou à proposer de nouvelles solutions à leurs clients.",
    icon: Users,
    characteristics: [
      "Expertise dans leur domaine",
      "Réseau professionnel établi",
      "Capacité à identifier des opportunités",
      "Autonomie dans la gestion de projets"
    ]
  },
  {
    title: "Entreprises",
    description: "Dirigeants et décideurs d'entreprises de toutes tailles cherchant à digitaliser leurs processus ou développer de nouvelles solutions.",
    icon: Building2,
    characteristics: [
      "Budget défini pour le projet",
      "Besoins clairement identifiés",
      "Décision d'investissement validée",
      "Projet avec un ROI mesurable"
    ]
  },
  {
    title: "Agences",
    description: "Agences de communication, marketing digital ou conseil en transformation numérique qui souhaitent proposer des solutions techniques à leurs clients.",
    icon: Briefcase,
    characteristics: [
      "Portefeuille clients qualifié",
      "Expertise en conseil",
      "Capacité à gérer des projets",
      "Réseau professionnel étendu"
    ]
  }
];

const TargetSection = () => {
  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Nos Clients Cibles
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Nous accompagnons des organisations ambitieuses dans leur transformation numérique et leur développement.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {targets.map((target, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl border border-slate-200 p-8 hover:border-orcsys-500 transition-all duration-300 hover:shadow-lg"
            >
              <div className="flex md:flex-row flex-col items-start gap-4">
                <div className="bg-orcsys-50 p-3 rounded-lg">
                  <target.icon className="h-6 w-6 text-orcsys-500" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-3">
                    {target.title}
                  </h3>
                  <p className="text-slate-600 mb-4">
                    {target.description}
                  </p>
                  <ul className="space-y-2">
                    {target.characteristics.map((characteristic, idx) => (
                      <li key={idx} className="flex items-center text-slate-600">
                        <span className="w-1.5 h-1.5 bg-orcsys-500 rounded-full mr-2"></span>
                        {characteristic}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetSection; 